import axios from 'axios';
import { API_CONFIG } from '../config/env';

export interface ManualSettlementRequest {
  cryptoAmount: number;
  cryptoCurrency: string;
  fundingTxHash?: string;
  note?: string;
}

class TransactionOperationsService {
  private getAuthHeaders() {
    const token = localStorage.getItem('accessToken');
    return {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    };
  }

  async completeManualSettlement(transactionId: number, payload: ManualSettlementRequest): Promise<unknown> {
    const response = await axios.post(
      `${API_CONFIG.BASE_URL}/Transactions/${transactionId}/manual-settlement`,
      payload,
      { headers: this.getAuthHeaders() }
    );
    return response.data;
  }
}

export const transactionOperationsService = new TransactionOperationsService();
